<template>
	<div class="job-status">
		<div class="content-group">
			<p class="col-md-6">Job Status: {{ job_status }}</p>
			<p class="col-md-6" v-if="staff_name">Owned by: {{ staff_name }}</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'JobStatus',
	props: {
		job_status: {
			type: String,
			required: true
		},
		staff_name: {
			type: String
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/components/jobStatus.scss';
</style>
